import Axios, * as others from 'axios';
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';
import React, { Component,useEffect, useState } from "react";
import './activity.css';
import { format } from "date-fns";
import { Link } from 'react-router-dom';

const Activity = () => {
  const [ActivityData, setActivityData] = useState([]);
  const [ActivityLoan, setActivityLoading] = useState(true);
  const [errorActivity, setActivityError] = useState(null);

  useEffect(() => {

    const fetchActivityData = async () => {

          Axios.get(URL + `api/Activity/GetActivitys`).then((response) => {
            const res = response.data;
            //console.log(res);
    
            setActivityData(response.data);
            setActivityLoading(false);   
    
          }).catch((error) => {
            setActivityError(error);
            setActivityLoading(false); 
    
          });
      };
    
      // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
      fetchActivityData();

      // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
      return () => {
        // ทำการคืนการทำงานที่ต้องการ (cleanup)
        //console.log('Component unmounted');
      };

  }, []);

  if (ActivityLoan) {
      return <div>Loading...</div>;
  }

  if (errorActivity) {
      return <div>Error: {errorActivity.message}</div>;
  }

  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;<a href="activity" className="a-breadcrumbs">กิจกรรมสหกรณ์</a>
            </div>
          </div>
        </div>
      </section>
      <section id="services" className="services section">
        <div className="container section-title">
          <h2>กิจกรรมสหกรณ์</h2>
        </div>
        <div className="container" >
          <div className="row gy-5">

          {
            ActivityData.map((act) => (
              <div key={act.id} className="col-xl-4 col-md-6">
                <div className="service-item">
                  <div className="img">
                    <img src={`${IMGPATHS}` + `Img/Activity/${act.id}/${act.img}`} className="img-fluid" alt={act.topic} />
                  </div>
                  <div className="details position-relative">
                    <div className="icon">
                      <i className="bi bi-easel" />
                    </div>
                      <a href={`ActivityDetail/` + act.id} target='_blank' className="stretched-link">
                        <h3>{act.topic}</h3>
                        <p style={{fontSize:'20px'}}>{act.description}</p>
                        {/* <p style={{fontSize:'18px'}}>By {act.update_by}, Post On {format(new Date(act.update_day), "d MMMM, yyyy")}</p> */}
                      </a>
                    </div>
                  </div>
              </div>

              ))
            }
                              
          </div>
        </div>
      </section>

    </div>
  );
}

export default Activity;
